// extracted by mini-css-extract-plugin
module.exports = {"navItem":"_GqsG2lD","linkIcon":"X3w8wXuU","active":"__2RxUBizE","collapsed":"IzKZn_j3","title":"i6Xo9tIm","icon":"eLOgPHHe","extra":"mFweiJl1"};